import SelectFilter from '../templates/SelectFilter';
import { useDebounce } from '@vindr/utils/hooks/useDebounce';
import { useGetRoles } from '@vindr/services/actions/role.action';
import { getRoles } from '@vindr/services/apis/role.api';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface Role extends SelectFilter {
  params?: Parameters<typeof getRoles>['0'];
}

const Role = ({
  title,
  placeholder,
  value,
  onChange,
  width = 200,
  mode = 'multiple',
  params,
}: Role) => {
  const { t } = useTranslation('Vindoc');
  title = ['boolean', 'string'].includes(typeof title) ? title : t('Roles');
  placeholder = placeholder || t('Select Roles');

  const [searchTerm, handleSearch] = useDebounce<string>();
  const { data, isInitialLoading, isRefetching } = useGetRoles({
    offset: 0,
    limit: 100,
    ...params,
    name: searchTerm,
  });

  const roles = data?.data?.data;

  const options = useMemo(
    () => roles?.map((role) => ({ value: role.code, label: role.name })),
    [roles]
  );

  return (
    <SelectFilter
      loading={isInitialLoading || isRefetching}
      {...{ width, value, title, placeholder, onChange, options, mode }}
      searchVietnamese
      onSearch={handleSearch}
    />
  );
};

export default memo(Role, (prevProps, nextProps) => {
  return prevProps.value === nextProps.value;
});
